module.exports = __webpack_public_path__ + "static/media/event.0b9085a8.jpg";